import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { AttributeString, attributeStringEnumParser } from '~app-ui-new/utils';

import { UiNewButtonBase } from '../base.component';

export enum OutlineButtonVariant {
	PRIMARY = 'PRIMARY',
	CURRENT_COLOR = 'CURRENT_COLOR',
	WHITE = 'WHITE',
}

export enum OutlineButtonLateralPadding {
	LARGE = 'LARGE',
}

@Component({
	selector: '[uiNewButtonOutline],[uiNewButtonBordered]',
	templateUrl: './outline.component.html',
	styleUrls: ['./outline.component.scss', '../base.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
})
export class UiNewButtonOutlineComponent extends UiNewButtonBase {
	protected extraClassesKeys: Array<keyof this> = ['variant', 'lateralPadding'];

	private _variant: OutlineButtonVariant | null = null;

	@Input()
	public set variant(variant: AttributeString<OutlineButtonVariant>) {
		this._variant = attributeStringEnumParser(variant, OutlineButtonVariant, null);
	}

	public get variant() {
		return this._variant as AttributeString<OutlineButtonVariant>;
	}

	private _lateralPadding: OutlineButtonLateralPadding | null = null;

	@Input()
	public set lateralPadding(lateralPadding: AttributeString<OutlineButtonLateralPadding>) {
		this._lateralPadding = attributeStringEnumParser(
			lateralPadding,
			OutlineButtonLateralPadding,
			null
		);
	}

	public get lateralPadding() {
		return this._lateralPadding as AttributeString<OutlineButtonLateralPadding>;
	}
}
